import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";

export default function TermsOfUse() {
  return (
    <div
      className="min-h-screen font-sans"
      style={{ backgroundColor: "#FEF7EB" }}
    >
      <Navbar />
      <section className="pt-40 pb-24 px-6 md:px-16">
        <div className="max-w-3xl mx-auto">
          <p
            className="text-xs font-semibold uppercase tracking-widest mb-4"
            style={{ color: "#0073E5" }}
          >
            Legal
          </p>
          <h1 className="text-4xl md:text-5xl font-bold text-black mb-8">
            Terms of Use
          </h1>
          <p className="text-sm text-gray-400 mb-10">
            Last updated: April 14, 2026
          </p>
          <div className="space-y-8 text-gray-600 text-sm leading-relaxed">
            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                1. Introduction
              </h2>
              <p>
                Welcome to this website (the "Site"), operated by London App
                Syndicate LTD ("Company", "we", "our", or "us").
              </p>
              <div className="font-bold mt-3">Registered Office:</div>
              <div className="font-normal">
                <p>International House</p>
                <p>22-28 Wood Street</p>
                <p>Doncaster</p>
                <p>England</p>
                <p>DN1 3LW</p>
              </div>
              <div className="font-bold mt-3">Contact Information:</div>
              <div className="font-normal">
                <p>Email: support@londonappsco.com</p>
                <p>Phone: +447520663996</p>
              </div>
              <p className="mt-3">
                These Terms of Use ("Terms") govern your access to and use of
                the Site and any content, information, or services made
                available through it (collectively, the "Service").
              </p>
              <p className="mt-3">
                By accessing or using the Site, you confirm that you have read,
                understood, and agree to be bound by these Terms, as well as our
                Privacy Policy and Cookie Policy. If you do not agree, you must
                not use the Site.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                2. Definitions
              </h2>
              <p>For the purposes of these Terms:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  "Site" means this website and all related pages, features, and
                  content
                </li>
                <li>"Company" refers to London App Syndicate LTD</li>
                <li>
                  "Service" means any content, materials, or functionality
                  provided through the Site
                </li>
                <li>
                  "User", "you" means any person accessing or using the Site
                </li>
                <li>
                  "Content" means all text, graphics, logos, media, and
                  materials available on the Site
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                3. Eligibility
              </h2>
              <p>By using the Site, you confirm that:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  You are at least 18 years old or the age of majority in your
                  jurisdiction
                </li>
                <li>
                  You have the legal capacity to enter into binding agreements
                </li>
                <li>
                  You will comply with all applicable laws and regulations
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                4. Use of the Site
              </h2>
              <p>
                You agree to use the Site only for lawful purposes and in
                accordance with these Terms.
              </p>
              <p className="mt-2">You must not:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Use the Site in violation of any applicable laws</li>
                <li>Attempt to gain unauthorized access to systems or data</li>
                <li>
                  Interfere with the operation, security, or integrity of the
                  Site
                </li>
                <li>
                  Use automated tools (bots, scrapers) without authorization
                </li>
                <li>
                  Engage in any activity that may harm the Company or other
                  users
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                5. Intellectual Property Rights
              </h2>
              <p>
                All Content and materials on the Site are owned by or licensed
                to London App Syndicate LTD and are protected by intellectual
                property laws.
              </p>
              <p className="mt-2">
                You are granted a limited, non-exclusive, non-transferable
                license to access and use the Site for personal or internal
                business purposes.
              </p>
              <p className="mt-2">You may not:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  Copy, reproduce, or distribute Content without permission
                </li>
                <li>Modify or create derivative works</li>
                <li>
                  Use Company branding, trademarks, or logos without written
                  consent
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                6. User Content and Communications
              </h2>
              <p>
                If you submit any content, inquiries, or communications through
                the Site:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>You retain ownership of your content</li>
                <li>
                  You grant the Company a non-exclusive, royalty-free right to
                  use such content for operational purposes (e.g., responding to
                  inquiries)
                </li>
                <li>
                  You confirm that your content does not violate any laws or
                  third-party rights
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                7. Third-Party Services and Links
              </h2>
              <p>
                The Site may contain links to third-party websites or services.
              </p>
              <p className="mt-2">The Company:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Does not control third-party services</li>
                <li>
                  Is not responsible for their content, availability, or
                  policies
                </li>
                <li>Does not guarantee their accuracy or reliability</li>
              </ul>
              <p className="mt-2">
                Use of third-party services is at your own risk.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                8. Disclaimer of Warranties
              </h2>
              <p>
                The Site and all Content are provided on an "as is" and "as
                available" basis.
              </p>
              <p className="mt-2">
                To the fullest extent permitted by law, the Company:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  Makes no warranties regarding accuracy, completeness, or
                  reliability
                </li>
                <li>
                  Does not guarantee uninterrupted or error-free operation
                </li>
                <li>
                  Does not guarantee the absence of viruses or harmful
                  components
                </li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                9. Limitation of Liability
              </h2>
              <p>
                To the maximum extent permitted by law, London App Syndicate LTD
                shall not be liable for:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Any indirect, incidental, or consequential damages</li>
                <li>Loss of profits, data, or business opportunities</li>
                <li>
                  Any damages arising from use or inability to use the Site
                </li>
              </ul>
              <p className="mt-2">
                Nothing in these Terms excludes liability that cannot be
                excluded under applicable law.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                10. User Responsibility
              </h2>
              <p>You are responsible for:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>
                  Ensuring your use of the Site complies with applicable laws
                </li>
                <li>Maintaining the security of your devices and data</li>
                <li>Any actions taken while using the Site</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                11. Privacy and Data Protection
              </h2>
              <p>Your use of the Site is subject to our Privacy Policy.</p>
              <p className="mt-2">
                We process personal data in accordance with applicable data
                protection laws, including UK GDPR where applicable.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                12. Modifications to the Site and Terms
              </h2>
              <p>The Company reserves the right to:</p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>Modify or discontinue any part of the Site at any time</li>
                <li>Update these Terms when necessary</li>
              </ul>
              <p className="mt-2">
                Updated Terms will be posted on this page. Continued use of the
                Site constitutes acceptance of the updated Terms.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                13. Suspension and Termination
              </h2>
              <p>
                We reserve the right to suspend or restrict access to the Site
                if:
              </p>
              <ul className="list-disc pl-5 mt-2 space-y-1">
                <li>You violate these Terms</li>
                <li>Your use poses a risk to the Site or other users</li>
                <li>Required by law or regulatory authorities</li>
              </ul>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                14. Governing Law
              </h2>
              <p>
                These Terms shall be governed by and interpreted in accordance
                with the laws of England and Wales.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                15. Severability
              </h2>
              <p>
                If any provision of these Terms is found to be invalid or
                unenforceable, the remaining provisions shall remain in full
                force and effect.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                16. Entire Agreement
              </h2>
              <p>
                These Terms constitute the entire agreement between you and the
                Company regarding use of the Site and supersede any prior
                agreements.
              </p>
            </div>

            <div>
              <h2 className="text-lg font-bold text-black mb-3">
                17. Contact Information
              </h2>
              <p>London App Syndicate LTD</p>
              <p>International House</p>
              <p>22-28 Wood Street</p>
              <p>Doncaster</p>
              <p>England</p>
              <p>DN1 3LW</p>
              <p className="mt-2">Email: support@londonappsco.com</p>
              <p>Phone: +447520663996</p>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
